<script lang="ts">
	//Hooks
	import { createEventDispatcher, onMount } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button, Modal, Container } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';
	import type { Peripheral } from 'src/types/Peripherals';
	import LocalActions from './LocalActions.svelte';

	export let device: Device,
		action: ActionJob,
		switchPeripheral: Peripheral = null,
		scheduleAction: boolean = false,
		modalTitle = $format('button_add_local_action', {
			default: 'Add local action',
		});

	let localActionsRef: LocalActions;
	let disableSaveBtn = false;
	let showModal = false;

	const dispatch = createEventDispatcher();

	function handleSave() {
		const result = localActionsRef.save();
		if (!result) return;

		showModal = false;
		setTimeout(() => dispatch('save', result), durationFadeInOut);
	}

	onMount(() => {
		showModal = true;
	});

	const durationFadeInOut = 300;
	const onClose = () => {
		showModal = false;
		setTimeout(() => dispatch('close'), durationFadeInOut);
	};
</script>

<Modal title={modalTitle} {showModal} on:close={onClose} removeScrollPadding>
	<Container slot="content" noScroll padding="scrollPaddings" class="pb-s">
		<LocalActions
			bind:this={localActionsRef}
			bind:disableSaveBtn
			{device}
			{action}
			{switchPeripheral}
			{scheduleAction}
		/>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			variant="secondary"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onClose}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			disabled={disableSaveBtn}
			responsiveSize={{
				sm: 'm',
			}}
			on:click={handleSave}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
